import { AxiosResponse } from 'axios';
import axiosInstance from '../../../services/axios/axios';
import { then } from '../../../services/axios/_utility';
import { WrapImsPacket } from '../../../store/utility';

/**
 * Asynchronously adds application(s) to existing request.
 *
 * @function
 * @param {string} trackingNumber unique identifier of existing request.
 * @param {Object} cart application shopping cart.
 * @param {Object[]} cart.Items list of applications to add to existing request.
 * @param {number} cart.Items[].ID unique identifier of application to add.
 * @param {string} cart.Items[].ActionType type of action to take on application.
 * @returns {Promise<AxiosResponse<boolean>>} success indication.
 */
export const postAppAdd = async (trackingNumber, cart) => {
	return await axiosInstance
		.post(
			`api/Applications/Requests/${trackingNumber}/Add`,
			WrapImsPacket(cart)
		)
		.then(response => {
			return then(response, payload => payload);
		})
		.catch(error => {
			throw error.cause ? error.cause : error;
		});
};
